module.exports = __webpack_public_path__ + "static/media/calendar.b3d6e64c.svg";